import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { AlertController, PopoverController, ActionSheetController, LoadingController, Platform, NavController, ModalController } from '@ionic/angular';
import { InsuranceParamModel, InsuranceProviderManuModelVariantModel, InsuranceProviderValidationModel } from 'app/models/dms/insuranceProviderValidation.model';
import { ReportDynamicParametersModel } from 'app/models/dms/reportParameter.model';
import { ReportSpecModel } from 'app/models/dms/reportSpec.model';
import { SaleDetails_SaleProduct, SaleDetails_Vehicle, SaleDetailsModel } from 'app/models/dms/saleDetails.model';
import { GeneralService } from 'app/services/general.service';
import { ReportService } from 'app/services/report.service';
import { SaleService } from 'app/services/sale.service';
import { StorageService } from 'app/services/storage.service';
import { TaskService } from 'app/services/task.service';
import { UserService } from 'app/services/user.service';
import { Constants } from 'app/utility/constants';
import { FormFieldType, InsuranceParamType, MotorcentralEdition, ProductClass, WorkflowAction } from 'app/utility/enums';
import { firstValueFrom, timeout } from 'rxjs';
import { EditorPageComponent } from '../editor-page/editor-page.component';
import { ProductQuoteModel } from 'app/models/dms/productQuote.model';
import { ProductQuoteComponent } from '../product-quote/product-quote.component';

@Component({
    selector: 'app-provider-qualify',
    templateUrl: './provider-qualify.component.html',
    styleUrls: ['./provider-qualify.component.scss'],
    standalone: false
})
export class ProviderQualifyComponent extends EditorPageComponent implements OnInit
{
    @Input() insuranceProviderValidation: InsuranceProviderValidationModel;
    @Input() vehicle: SaleDetails_Vehicle;
    @Input() sale: SaleDetailsModel;
    @Input() productClass: ProductClass;
    @Input() isModal: boolean = true;
    @Input() insuranceParams: InsuranceParamModel[];
    @Input() wizardButtonText: string = "Next";
    @Input() parentShowLoading: boolean = false;

    @Output() stepForward = new EventEmitter<InsuranceProviderValidationModel>();
    @Output() stepBackward = new EventEmitter<InsuranceProviderValidationModel>();

    showLoading: boolean = true;
    isExpress: boolean = false;

    constructor(
        public generalService: GeneralService, //for lookups - todo: remove
        public userService: UserService,
        public route: ActivatedRoute,
        public titleService: Title,
        public storage: StorageService,
        public alertController: AlertController,
        public popoverController: PopoverController,
        public actionSheetController: ActionSheetController,
        public loadingController: LoadingController,
        protected cd: ChangeDetectorRef,
        public platform: Platform,
        public navCtrl: NavController,
        public modalController: ModalController,
        private saleService: SaleService
    )
    {
        super(userService, route, titleService, storage, alertController, popoverController, actionSheetController, loadingController, cd, platform);
        this.editActive = true;
    }
    
    mcOnInit()
    {
        this.isDirty = true;
        this.activeSegment = 'general';
        this.setupTitle();
        this.userService.getLicence()
            .subscribe({
                next: async license =>
                {
                    this.isExpress = (license.motorcentralEdition == MotorcentralEdition.Express);
                },
                error: err =>
                {
                    this.handleError(err);
                }
            });

        if (!this.isModal)
        {
            this.fetchObject();
        }
    }

    mcViewDidEnter()
    {
        this.activeSegment = "general";
    }

    public getHeadingTitle(): string
    {
        if (this.insuranceProviderValidation && this.insuranceProviderValidation.selectedInsuranceProvider)
        {
            return this.insuranceProviderValidation.selectedInsuranceProvider.caption;
        }
        else
        {
            return "Insurance";
        }
    }

    public getPageName(): string
    {
        return "Insurance";
    }


    mcOnDestroy()
    {

    }

    public fetchTemplate()
    {

    }

    editLaunched: boolean = false;
    public async fetchObject()
    {
        this.setEdit(true);

        this.showLoading = true;

        if (this.insuranceParams && this.insuranceParams.length > 0)
        {
            this.setupFieldGroups();
        }
        else
        {

            this.subscription = this.saleService.getInsuranceDynamicValidationParams(this.insuranceProviderValidation)
                .pipe(timeout(Constants.ApiShortTimeout))
                .subscribe
                ({
                    next: async result =>
                    {
                        this.insuranceParams = result.insuranceParams;                  
                        
                        this.setupTitle();
                        this.setupFieldGroups();
                    },
                    error: err =>
                    {
                        this.showLoading = false;
                        this.skeleton = false;
                        this.handleError(err);
                    }
                });
        }
        
    }

    async validateAnswers(paramPayload: InsuranceProviderValidationModel): Promise<boolean>
    {
        var disclaimerParam = paramPayload.insuranceParams.find(x => x.paramFieldType == FormFieldType.General_Disclaimer && x.paramType == InsuranceParamType.Checkbox);
        if (disclaimerParam && disclaimerParam.paramValue != 'on')
        {
            this.presentAlert("Validation Error", "You must confirm the you and the customer have read, understood and accept the Responsible Lending Code and other Terms & Conditions related to this product.");
            return false;
        }

        try
        {
            await firstValueFrom(this.saleService.validateInsuranceParams(paramPayload));
        }
        catch (err)
        {
            this.userService.handleError(err);
            return false;
        }

        var installmentParam = paramPayload.insuranceParams.find(x => x.paramFieldType == FormFieldType.Sale_Finance_Installment);

        if (installmentParam && (Math.abs(this.sale.summary.summaryRepaymentMonth - installmentParam.paramValue) / this.sale.summary.summaryRepaymentMonth >= 0.1))
        {
            return new Promise<boolean>(async (resolve) => {
                const alert = await this.alertController.create({
                    header: "Confirm",
                    message: `The Monthly Instalment amount ${installmentParam.paramValue?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} is significantly different from that expected ${this.sale.summary.summaryRepaymentMonth?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}. Are you sure you want to continue?`,
                    buttons: [
                        {
                            text: 'No',
                            role: 'cancel',
                            cssClass: 'primary',
                            handler: () => {
                                //return false to stop submission
                                alert.dismiss();
                                resolve(false);
                            }
                        },
                        {
                            text: 'Yes',
                            cssClass: 'danger',
                            handler: () => {
                                resolve(true);
                            }
                        }
                    ]
                });
                await alert.present();
            });
        }
        else
        {
            return true;
        }
    }


    async submitQuestionnaire(paramPayload: InsuranceProviderValidationModel, quoteResult: ProductQuoteModel = null)
    {

        const loading = await this.loadingController.create({
            message: 'Submitting...',
            duration: 60000
        });
        await loading.present();

        this.saleService.submitInsuranceParams(paramPayload)
            .subscribe({
                next: product =>
                {
                    loading.dismiss();
                    this.modalController.dismiss({
                            'result': {
                                save: true,
                                saleProduct: product,
                                quoteResult: quoteResult
                            }
                        });
                },
                error: error =>
                {
                    loading.dismiss();
                    this.handleError(error);
                }
            });
    }


    public async setupFieldGroups(): Promise<void>
    {
        this.fieldGroupTabs = await this.saleService.setupInsuranceFieldGroups(this.insuranceParams, this.isDirty);
        this.skeleton = false;
        this.showLoading = false;
    }



    public handleFieldChangedAdditional(ev: any): void
    {
        if (!(ev.detail)) return;

        switch (ev.detail.id)
        {
            case "manufacturer":
                this.getProviderManuModelVariant(ev.detail.value, null);
                break;
            case "model":
                this.getProviderManuModelVariant(null, ev.detail.value);
                break;           
        }
    }

    async getProviderManuModelVariant(manufacturerId: string, modelId: string)
    {   
        const loading = await this.loadingController.create({
            message: 'Loading...',
            duration: 60000
        });
        await loading.present();

        var manuModelVariant = this.populateManuModelVariantModel(manufacturerId, modelId);
        
        this.saleService.getProviderManuModelVariant(manuModelVariant)
            .subscribe({
                next: result =>
                {
                    loading.dismiss();
                    
                    this.fieldGroupTabs.forEach(group => {
                        group.fieldGroups.forEach(fg => {
                            fg.fields.forEach(field => {
                                if (field.id == "manufacturer")
                                {
                                    field.detailObject = this.saleService.getListItemFromLookupExternal(result.manufacturers);
                                    field.value = result.manufacturers.find(x => x.caption == manuModelVariant.selectedManufacturerCaption).id;
                                    field.valueChanged$.next(null);
                                }
                                if (field.id == "model")
                                {
                                    field.detailObject = this.saleService.getListItemFromLookupExternal(result.models);
                                    if (manuModelVariant.selectedModelCaption)
                                    {
                                        field.value = result.models.find(x => x.caption == manuModelVariant.selectedModelCaption).id;
                                    }
                                    else
                                    {
                                        field.value = Constants.EmptyGuid;
                                    }
                                    field.valueChanged$.next(null);
                                }
                                if (field.id == "variant")
                                {
                                    if (result.modelId != Constants.EmptyGuid)
                                    {
                                        field.detailObject = this.saleService.getListItemFromLookupExternal(result.variants);
                                        field.editable = true;
                                    }
                                    else
                                    {
                                        field.editable = false;
                                    }

                                    if (result.selectedVariantCaption)
                                    {
                                        field.value = result.variants.find(x => x.caption == result.selectedVariantCaption).id;
                                    }
                                    else
                                    {
                                        field.value = Constants.EmptyGuid;
                                    }

                                    field.valueChanged$.next(null);
                                }

                            });
                        });
                    });
                    
                },
                error: err =>
                {
                    loading.dismiss();
                    this.handleError(err);
                }
            });
    }

    populateManuModelVariantModel(manufacturerId: string, modelId: string, useExisting: boolean = false): InsuranceProviderManuModelVariantModel
    {
        var manuModelVariant = new InsuranceProviderManuModelVariantModel();
        manuModelVariant.saleId = this.insuranceProviderValidation.saleId;
        manuModelVariant.vehicleId = this.insuranceProviderValidation.vehicleId;
        manuModelVariant.selectedInsuranceProviderEnum = this.insuranceProviderValidation.selectedInsuranceProviderEnum;
        manuModelVariant.productClass = this.productClass;

        var manufacturer = null;
        var model = null;
        var variant = null;

        this.fieldGroupTabs.forEach(group => {
            group.fieldGroups.forEach(fg => {
                fg.fields.forEach(f => {
                    if (f.id == "manufacturer")
                    {
                        manufacturer = f;
                    }
                    if (modelId && f.id == "model" || useExisting && f.id == "model")
                    {
                        model = f;
                    }
                    if (useExisting && f.id == "variant")
                    {
                        variant = f;
                    }
                });
            });
        });
        if (!manufacturerId) 
        {
            if (manufacturer && manufacturer.value)
            {
                manufacturerId = manufacturer.value;
            }
            else
            {
                return manuModelVariant;
            }
        }
        manuModelVariant.manufacturerId = manufacturerId;
        if (manufacturer && manufacturer.detailObject)
        {
            manuModelVariant.selectedManufacturerCaption = manufacturer.detailObject.find(x => x.id == manufacturerId)?.name;
        }

        if (modelId)
        {
            manuModelVariant.modelId = modelId;
            if (model && model.detailObject)
            {
                manuModelVariant.selectedModelCaption = model.detailObject.find(x => x.id == modelId).name;
            }
        }
        else if (useExisting)
        {
            if (model && model.value != Constants.EmptyGuid)
            {
                manuModelVariant.modelId = model.value;
                if (model && model.detailObject)
                {
                    manuModelVariant.selectedModelCaption = model.detailObject.find(x => x.id == manuModelVariant.modelId).name;
                }
            }
            
            if (variant && variant.value != Constants.EmptyGuid)
            {
                manuModelVariant.variantId = variant.value;
                if (variant && variant.detailObject)
                {
                    manuModelVariant.selectedVariantCaption = variant.detailObject.find(x => x.id == manuModelVariant.variantId).name;
                }
            }
        }

        return manuModelVariant;
    }

    async cancelModal()
	{
		// console.log('cancelModal', this.isDirty);
		if (this.isDirty)
		{
			//prompt user to save
			const alert = await this.alertController.create({
				header: "Unsaved Changes",
				message: "Some data has changed. Do you want to close without saving?",
				buttons: [
					{
						text: 'Cancel',
						role: 'cancel',
						cssClass: 'primary',
						handler: () =>
						{
							//do nothing
							return;
						}
					},
					{
						text: 'OK',
						cssClass: 'danger',
						handler: () =>
						{
							this.dismissTheModal(false);
						}
					}
				]
			});

			await alert.present();
		}
		else
		{
			this.dismissTheModal(false);
		}
	}

    async dismissTheModal(save: boolean)
	{
		// console.log('dismissTheModal', save);
		// Dismiss the top modal returning some data object
        if (save)
        {
            if (this.isModal)
            {
                this.registerSaleProduct();
            }
            else
            {
                this.emitStepForward();
            }
        }
        else
        {
            this.modalController.dismiss({
                'result': {
                    save: false
                }
            });
        }
	}

    async doRefresh(ev: any)
	{
		setTimeout(() =>
		{
			this.fetchObject();
			ev.target.complete();
		}, 250);
	}

    getQuestionnaireParamsAsParamPayload(): InsuranceProviderValidationModel
    {
        var paramPayload = JSON.parse(JSON.stringify(this.insuranceProviderValidation)) as InsuranceProviderValidationModel;
        paramPayload.insuranceParams = [];
        
        console.log(this.insuranceParams);
        for (let fieldGroupTab of this.fieldGroupTabs)
        {
            for (let fieldGroup of fieldGroupTab.fieldGroups)
            {
                for (let field of fieldGroup.fields)
                {
                    //find the item in the param sets
                    let paramSet = this.insuranceParams.find(x => x.paramId == field.id);

                    paramSet.paramValue = field.value || null;

                    let existing = paramPayload.insuranceParams.find(x => x.paramId == paramSet.paramId);
                    if (!existing)
                    {
                        paramPayload.insuranceParams.push(paramSet);
                    }
                }
            }
        }

        paramPayload.manuModelVariant = this.populateManuModelVariantModel(null, null, true);

        return paramPayload;
    }

    emitStepForward()
    {
        var currentAnswers = this.getQuestionnaireParamsAsParamPayload();
        this.stepForward.emit(currentAnswers);
    }

    public emitStepBackward()
    {
        var currentAnswers = this.getQuestionnaireParamsAsParamPayload();
        this.stepBackward.emit(currentAnswers);
    }

    async registerSaleProduct()
    {
        const loading = await this.loadingController.create({
            message: 'Loading...',
            duration: 60000
        });
        await loading.present();

        var paramPayload = this.getQuestionnaireParamsAsParamPayload();

        if (await this.validateAnswers(paramPayload))
        {
            this.saleService.registerSaleWorkflowProduct(paramPayload, WorkflowAction.Quote)
            .subscribe({
                next: async (quoteResult) =>
                {
                    loading.dismiss();
                    if (quoteResult)
                    {
                        if (quoteResult.requiresReferral)
                        {
                            const alert = await this.alertController.create({
                                header: 'Requires referral',
                                message: quoteResult.referredMessage + '<br><br>Would you like to submit the proposal for referral consideration?',
                                buttons: [
                                    {
                                        text: 'No',
                                        role: 'cancel',
                                        cssClass: 'secondary',
                                        handler: () =>
                                        {
                                            if (quoteResult.generalMessage && quoteResult.generalMessage.length > 0)
                                            {
                                                this.userService.presentAlert('Information', quoteResult.generalMessage);
                                            }
                                            this.dismissTheModal(false);
                                        }
                                    },
                                    {
                                        text: 'Yes',
                                        handler: async () =>
                                        {
                                            const loading = await this.loadingController.create({
                                                message: 'Registering...',
                                                duration: 60000
                                            });

                                            await loading.present();
                                            
                                            if (quoteResult.mviQuote.products.length == 0)
                                            {
                                                if (paramPayload.productClass === ProductClass.VehicleInsurance)
                                                {
                                                    var saleAmountParam = paramPayload.insuranceParams.find(x => x.paramId == "saleAmount");
                                                    if (saleAmountParam)
                                                    {
                                                        saleAmountParam.paramValue = 0;
                                                    }
                                                    var taxAmountParam = paramPayload.insuranceParams.find(x => x.paramId == "saleProductTaxAmount");
                                                    if (taxAmountParam)
                                                    {
                                                        taxAmountParam.paramValue = 0;
                                                    }
                                                }
                                            }

                                            this.saleService.registerSaleWorkflowProduct(paramPayload, WorkflowAction.OrderPending)
                                                .subscribe({
                                                    next: async (x) =>
                                                    {
                                                        loading.dismiss();
                                                        this.modalController.dismiss({
                                                            'result': {
                                                                save: true,
                                                                quoteResult: x,
                                                            }
                                                        });
                                                    },
                                                    error: async (err) =>
                                                    {
                                                        loading.dismiss();
                                                        this.userService.handleError(err);
                                                    }
                                                });
                                        }
                                    }
                                ]
                            });
    
                            await alert.present();
                        }
                        else
                        {
                            if (quoteResult.generalMessage && quoteResult.generalMessage.length > 0)
                            {
                                this.userService.presentAlert('Information', quoteResult.generalMessage);
                                this.dismissTheModal(false);
                                return;
                            }
                            else
                            {
                                this.launchProductQuoteForm(paramPayload, quoteResult);
                            }

                        }
                    }
                    else
                    {
                        this.submitQuestionnaire(paramPayload);
                    }
                    


                },
                error: async (err) =>
                {
                    loading.dismiss();
                    this.userService.handleError(err);
                }
            });
            
        }
        else
        {
            loading.dismiss();
        }

    }

    async launchProductQuoteForm(paramPayload: InsuranceProviderValidationModel, quoteResult: ProductQuoteModel)
    {
        const modal = await this.modalController.create({
            component: ProductQuoteComponent,
            componentProps: {
                insuranceProviderValidation: paramPayload,
                quoteResult: quoteResult,
                vehicle: this.vehicle,
                sale: this.sale,
            },
            backdropDismiss: false
        });

        await modal.present();
        const { data } = await modal.onDidDismiss();

        if (data && data.result && data.result.save)
        {
            this.modalController.dismiss({
                'result': {
                    save: true,
                    mviObtained: true,
                }
            });
        }

    }

    

}